module.exports = __webpack_public_path__ + "img/password.32f25f02.svg";